<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester ssystem college department sclass keyword="學號、學生姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.rentstate" id="rentstate" label="賃居情形">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in rentstates" :key="o.key" :value="o.key">{{o.value}}</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>班級</th>
                            <th>學號-學生姓名</th>
                            <th>賃居情形</th>
                            <th>訪視次數</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.RentID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.RentID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="班級">{{item.ClassName}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.RentID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                        <td data-th="賃居情形">{{item.RentState|rentstate}}</td>
                        <td data-th="訪視次數">{{item.Views}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="rentstate">
                <div is="option" v-for="o in rentstates" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
        <inputmodal id="input" sample="/template/rent.xlsx" url="/api/rent/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './rentDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'rent',
        api: '/api/rent/',
        components: { Detail },
        data: { rentstates: [] },
        created: function () {
            window.rentstates = [];
            this.$parameter.rent().then((res) => { window.rentstates = this.rentstates = res.data; });
        },
        filters: {
            rentstate: function (value) { let a = window.rentstates.filter(x => x.key == value); return a.length > 0 ? a[0].value : ''; }
        },
    });
</script>

<style>
</style>